import React from "react";
import "../styles/Home.css";

function HomeContactSection({
  scale,
  formData,
  loading,
  success,
  error,
  handleChange,
  handleSubmit,
}) {
  return (
    <section className="Hcontact-section">
      <h2 className="Hcontact-heading">Contact Us...</h2>
      <p className="Hcontact-subtext">
        We’d love to hear from you! Reach out through any of the channels below
        or drop us a message directly.
      </p>

      <div className="Hcontact-container">
        <div className="Hcontact-left">
          <div className="Hcontact-title">
            <h3>TejCodex</h3>
            <img src={scale} alt="Scale" className="Hcontact-logo" />
          </div>

          <ul className="Hcontact-list">
            <li>
              <strong>Email:</strong>{" "}
              <a href="mailto:tejcodex@gmail.com">tejcodex@gmail.com</a>
            </li>
            <li>
              <strong>Support Hours: </strong>{" "}
              <a href="mailto:tejcodex@gmail.com">
                Mon–Fri, 9:00 AM – 6:00 PM IST
              </a>
            </li>

            <li>
              <strong>Follow Us on WhatsApp Channel:</strong>{" "}
              <a
                href="https://whatsapp.com/channel/0029Vb6pHKfFCCochOVJVm2a"
                target="_blank"
                rel="noopener noreferrer"
              >
                TejCodex
              </a>
            </li>
          </ul>

          <p className="Hcontact-text">
            🔎 If you find any mistakes or 📖 missing topics in the notes,
            kindly reach out to us. 📩 Your feedback 💡 helps us improve and
            serve law students 🎓 better! 🤝
          </p>
        </div>

        <div className="Hcontact-right">
          <div className="Hform-heading">
            <h3>Contact Form</h3>
            <img src={scale} alt="Scale" className="Hcontact-logo" />
          </div>

          <form className="Hcontact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="Hform-input"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="Hform-input"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Your Message"
              className="Hform-textarea"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit" className="Hform-button" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>

            {success && (
              <p className="Hsuccess-msg">Message sent successfully! 🎉</p>
            )}
            {error && (
              <p className="Herror-msg">Failed to send message ❌ Try again.</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default HomeContactSection;
